var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-arrow-sf",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.225 4.667a6.667 6.667 0 1 1 0 6.667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.667 10.667 8 8 5.333M1.333 8h9.334"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-close-sf",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 5 5 15M5 5l10 10"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-left-sf",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.75 13.5 4.5-4.5-4.5-4.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-pencil-sf",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m1.667 14.333 3.7-1.423c.236-.09.354-.136.465-.196.098-.052.192-.113.28-.182.1-.077.189-.166.368-.345L14 4.667A1.886 1.886 0 1 0 11.333 2l-7.52 7.52a4.16 4.16 0 0 0-.345.368c-.069.088-.13.182-.183.28-.059.11-.104.23-.195.466l-1.423 3.7Zm0 0 1.372-3.567c.098-.255.147-.383.231-.441a.333.333 0 0 1 .253-.054c.1.02.197.116.39.31l1.507 1.505c.193.194.29.29.309.391a.334.334 0 0 1-.054.253c-.058.084-.186.133-.441.231l-3.567 1.372Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-right-sf",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.25 13.5 6.75 9l4.5-4.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar-trash-sf",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M6 2h4M2 4h12M3.333 4l.4 6.009c.075 1.115.112 1.673.295 2.121a3 3 0 0 0 1.836 1.718C6.323 14 6.882 14 8 14v0c1.118 0 1.677 0 2.136-.152a3 3 0 0 0 1.836-1.718c.183-.448.22-1.006.294-2.121l.4-6.009"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "login-cloud",
    viewBox: "0 0 183 145"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E3F3FF",
    strokeWidth: 3,
    d: "m89.135 142.413-2.046-.665 1.331-1.69c2.352-2.986 5.362-8.103 6.712-13.659 1.347-5.541 1.003-11.292-2.973-15.917-1.09-1.268-3.22-2.414-6.44-3.439-3.166-1.008-7.15-1.828-11.699-2.598-3.18-.539-6.644-1.053-10.266-1.59-6.635-.984-13.802-2.047-20.738-3.486C32.27 97.14 21.73 93.953 14 88.546 6.176 83.075 1.207 75.302 1.806 64.145c1.145-21.314 6.741-37.97 14.401-48.706C23.847 4.732 33.79-.347 43.423 2.45c3.5 1.017 10.923 2.4 20.68 4.22 2.21.412 4.538.846 6.968 1.303 13.092 2.463 28.984 5.575 44.491 9.428 15.492 3.85 30.676 8.457 42.323 13.932 5.823 2.737 10.828 5.722 14.557 8.984 3.721 3.256 6.29 6.894 6.989 10.95 2.518 14.605.982 30.768-3.065 44.318-2.024 6.781-4.689 12.949-7.824 17.966-3.124 5-6.774 8.952-10.811 11.162-6.396 3.503-14.623 3.632-22.1 2.512-6.892-1.032-13.374-3.159-17.648-4.979-3.015 3.989-7.633 9.355-12.542 13.585-2.656 2.289-5.455 4.296-8.178 5.558-2.7 1.251-5.536 1.866-8.128 1.024Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "login-door-sf",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.5 2.5h1c1.4 0 2.1 0 2.635.272a2.5 2.5 0 0 1 1.092 1.093C17.5 4.4 17.5 5.1 17.5 6.5v7c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.092c-.535.273-1.235.273-2.635.273h-1M8.333 5.833 12.5 10m0 0-4.167 4.167M12.5 10h-10"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "login-rocket",
    viewBox: "0 0 369 447"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.469,
    cy: 220.023,
    fill: "#fff",
    rx: 29.975,
    ry: 37.767,
    transform: "rotate(-31.558 178.469 220.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.468,
    cy: 220.023,
    fill: "#fff",
    rx: 25.013,
    ry: 33.227,
    transform: "rotate(-31.558 178.468 220.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02,
    cy: 3.174,
    fill: "#fff",
    rx: 2.02,
    ry: 3.174,
    transform: "matrix(.92836 -.37381 .3727 .9271 131.684 166.524)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02,
    cy: 3.174,
    fill: "#fff",
    rx: 2.02,
    ry: 3.174,
    transform: "matrix(-.75943 .65182 .65117 .75788 152.212 153.404)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M138.192 153.512c-3.39 2.116-9.053 7.627-4.592 12.744 2.99 3.43 2.553 5.498 2.081 7.734-.409 1.933-.844 3.991.888 7.163 1.573 2.882 3.532 4.376 5.487 5.867 2.688 2.05 5.368 4.094 7.029 9.724 2.295 7.783 13.947 26.967 19.534 35.465l12.667-7.779 12.525-7.612c-4.969-8.874-16.341-27.977-22.191-33.6-4.121-3.961-4.079-7.211-4.036-10.45.033-2.507.066-5.009-1.833-7.83-2.029-3.015-4.548-3.569-6.972-4.102-2.775-.61-5.427-1.193-7.086-5.406-2.487-6.317-9.987-3.829-13.426-1.795l-.075-.123Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.882,
    cy: 6.877,
    fill: "#fff",
    rx: 4.882,
    ry: 6.877,
    transform: "matrix(-.55034 .83558 .8354 .54868 138.977 173.837)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.882,
    cy: 6.877,
    fill: "#fff",
    rx: 4.882,
    ry: 6.877,
    transform: "matrix(-1.00003 -.0248 -.0263 .99931 167.419 163.001)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M185.093 202.037c-6.68 9.419-19.418 15.226-25.13 16.008l1.863 2.933c13.374-.999 22.204-11.133 25.111-16.031l-1.844-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M186.906 204.84c-7.725 11.714-19.422 15.253-25.131 16.104l1.509 2.269c13.384-1.162 22.756-10.165 25.576-15.086l-1.954-3.287Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.906,
    cy: 1.424,
    fill: "#fff",
    opacity: 0.2,
    rx: 0.906,
    ry: 1.424,
    transform: "matrix(.9925 -.12664 .12525 .99156 151.018 154.994)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.906,
    cy: 1.424,
    fill: "#fff",
    opacity: 0.2,
    rx: 0.906,
    ry: 1.424,
    transform: "matrix(.9925 -.12664 .12525 .99156 132.909 166.374)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.661 171.644c-5.606-8.335 1.764-14.774 1.793-14.647 9.632-2.818 13.379 5.026 13.75 6.298 1.021 3.502 7.663 3.11 8.068 7.16.405 4.049 4.396 10.572 5.932 15.88.941 3.253.419 4.968-.231 5.718.217-.129.133-.063-.075.082a1.394 1.394 0 0 1-.518.352c.193-.129.382-.257.518-.352.025-.026.05-.053.075-.082-.286.17-1.091.677-2.814 1.784-4.862 3.123-9.101-3.158-17.851-7.963-8.75-4.805-1.64-3.811-8.647-14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.249 190.696c-4.159 2.054-10.752-5.922-13.529-10.168 2.103-2.009 6.91-5.953 9.318-5.662 3.009.364 9.41 13.261 4.211 15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.378 189.099c2.554-2.025-1.989-7.536-4.58-10.039l-5.368 3.263c2.251 3.102 7.393 8.801 9.948 6.776Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M162.758 187.123c.323-.754-4.143-6.225-6.417-8.867l-1.103.843c2.372 2.989 7.197 8.778 7.52 8.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.095 178.177c-.778-7.288-4.242-9.485-5.877-9.672.822-7.99 7.542-7.704 10.798-6.562.222 7.456-.128 1.596 7.112 8.922 5.791 5.86 2.677 10.941.396 12.749-3.819 1.224-11.651 1.85-12.429-5.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M161.202 173.519c-11.53-4.736-12.381 4.374-11.366 9.521 1.624 1.375 5.869 3.401 9.855.507 3.986-2.895 2.668-7.892 1.511-10.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M153.494 176.724c-.513-.688-1.581-1.888-1.751-1.184-.169.705 1.097 1.083 1.751 1.184ZM154.886 175.882c-.491-.704-1.293-2.097-.571-2.035.723.062.682 1.382.571 2.035ZM139.581 145.396l4.361 5.917c-1.43 5.377-8.51 8.025-11.871 8.678l-4.354-6.094 11.864-8.501Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.942 151.313c1.262 3.86.392 10.738-11.887 8.624l11.887-8.624Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.304,
    cy: 1.259,
    fill: "#fff",
    rx: 7.304,
    ry: 1.259,
    transform: "matrix(.81671 -.57849 .5777 .81522 126.972 152.837)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.839 151.949c.04-.005.071-.011.103-.012.26-.011.471.05.667.22.083.072.159.155.237.231.068.068.136.135.206.202.018.017.022.027.002.048-.043.043-.064.098-.047.159a.137.137 0 0 0 .104.101.159.159 0 0 0 .143-.035c.021-.017.028-.036.023-.065a1.557 1.557 0 0 0-.225-.604c-.096-.153-.22-.284-.337-.418-.067-.077-.132-.157-.201-.231a.609.609 0 0 1-.106-.155.414.414 0 0 1-.039-.189.329.329 0 0 1 .173.073c.046.039.087.085.126.13.041.049.076.103.114.153.1.132.198.265.302.394.174.214.39.37.646.465.034.014.059.005.083-.019a.16.16 0 0 0 .018-.215c-.047-.058-.14-.068-.206-.018-.024.018-.033.011-.045-.011l-.212-.333c-.079-.126-.165-.247-.206-.393a.92.92 0 0 1 .022-.556l.017-.047.023.029 1.28 1.586c.024.031.024.031-.004.054l-.326.27c-.019.016-.023.028-.011.051a.78.78 0 0 1 .066.545c-.009.04-.011.083-.016.125-.12-.022-.246 0-.366-.042a.825.825 0 0 1-.272-.147c-.018-.014-.031-.013-.048 0l-.33.274c-.02.016-.031.019-.049-.004l-1.287-1.595c-.005-.001-.01-.006-.022-.021Zm.319.147-.007.01a.74.74 0 0 0 .024.029l.61.757c.034.042.034.042.078.006.016-.013.021-.024.012-.044a.253.253 0 0 1 .002-.193c.01-.027.002-.042-.016-.059-.089-.085-.181-.171-.267-.26a.774.774 0 0 0-.291-.195c-.049-.02-.096-.034-.145-.051Zm1.131-.929c-.003.003-.006.002-.008.005a.44.44 0 0 0 .003.052c.014.127.023.229.088.338.084.139.171.275.257.412.01.019.023.026.048.022a.266.266 0 0 1 .188.036c.027.017.047.01.077-.026.018-.023-.003-.032-.013-.045a259.792 259.792 0 0 1-.64-.794Zm.038 1.826a.852.852 0 0 1-.029.014c-.102.052-.204.065-.304-.003-.014-.009-.024-.01-.035.002l-.029.024c-.013.011-.014.021-.003.035.083.104.168.209.254.312.004.005.025.009.03.004.075-.059.151-.122.223-.184.006-.005.009-.023.006-.03l-.113-.174Zm.585-.485.148.148c.014.014.025.005.036-.004.07-.058.137-.116.208-.172.022-.018.022-.032.004-.052-.076-.092-.15-.185-.226-.28-.035-.043-.035-.043-.077-.008-.012.011-.023.02-.015.038.041.102.018.195-.039.282-.013.018-.029.033-.039.048Zm-.605-.15c.048.138.093.274.113.419.065-.006.127-.011.19-.019.009 0 .02-.014.023-.024.018-.051.031-.103.049-.155.005-.016.002-.025-.015-.032a1.629 1.629 0 0 1-.333-.175l-.027-.014Zm.368.82c.052.077.244.159.303.139l.001-.005c-.058-.072-.115-.145-.173-.214-.005-.006-.021-.006-.028-.003-.036.025-.069.055-.103.083Zm.42.047c.031-.083-.02-.288-.074-.336l-.093.077c-.018.015-.018.027-.004.043l.14.175a.74.74 0 0 0 .031.041Zm-.461-.196c.018-.015.038-.029.054-.046.005-.005.007-.025.003-.028-.058-.054-.138-.075-.207-.042-.015.008-.019.016-.012.031l.077.126c.009.015.022.014.034.004l.051-.045Zm.252-.208.048-.04c.017-.012.021-.027.004-.042a2.819 2.819 0 0 0-.097-.093c-.017-.014-.028-.012-.04.007a.193.193 0 0 0 .002.209c.004.006.022.007.028.004.02-.014.037-.03.055-.045Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m139.581 145.396 4.361 5.917c-1.43 5.377-8.51 8.025-11.871 8.678l-4.354-6.094s1.1-.477 1.724-.914c.748-.524 1.697-1.608 1.697-1.608l7.07 2.96-2.012-6.896s1.304-.158 1.996-.584c.67-.412 1.389-1.459 1.389-1.459Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.206,
    cy: 224.499,
    fill: "#fff",
    rx: 14.761,
    ry: 4.019,
    transform: "matrix(.85211 -.52402 .5227 .85211 -90.548 128.156)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m162.796 225.326 28.205-17.323 6.777 11.035-28.204 17.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M238.204 329.162c-17.912-24.883-15.368-32.755-8.696-37.556 6.673-4.801 14.947-4.713 32.86 20.171 17.912 24.884 32.008 69.941 32.008 69.941-20.344-28.261-38.259-27.672-56.172-52.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M240.399 306.735c-17.913-24.884-15.369-32.756-8.697-37.557 6.673-4.801 14.947-4.712 32.86 20.172 17.913 24.883 32.008 69.94 32.008 69.94-20.343-28.26-38.259-27.671-56.171-52.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M211.412 317.421c-17.912-24.884-15.368-32.756-8.696-37.557 6.673-4.801 14.947-4.712 32.86 20.171 17.912 24.884 32.008 69.941 32.008 69.941-20.344-28.261-38.259-27.672-56.172-52.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7B7B7",
    d: "m94.059 162.614 76.346-46.891 91.94 149.692-76.346 46.891z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.078,
    cy: 288.708,
    fill: "#B7B7B7",
    rx: 44.798,
    ry: 17.71,
    transform: "rotate(-31.558 224.078 288.708)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "evenodd",
    d: "m166.661 109.625-76.346 46.891L182.12 305.99l.04.066.041.066.054.087.001-.001c5.283 8.137 26.393 4.363 47.346-8.506 20.954-12.87 33.865-29.991 28.996-38.383l.002-.001-91.939-149.693Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M89.675 155.477c18.254 29.721 94.703-17.233 76.449-46.955-24.961-40.64-90.815-60.776-90.815-60.776s-10.782 66.787 14.366 107.731Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m135.178 314.092 37.614-23.101-51.979-84.63s-10.782 66.787 14.365 107.731Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m286.854 220.934-37.613 23.102-51.978-84.63s64.444 20.583 89.591 61.528Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.469,
    cy: 220.023,
    fill: "#EDEDED",
    rx: 29.975,
    ry: 37.767,
    transform: "rotate(-31.558 178.469 220.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 178.468,
    cy: 220.023,
    fill: "#888",
    rx: 25.013,
    ry: 33.227,
    transform: "rotate(-31.558 178.468 220.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02,
    cy: 3.174,
    fill: "#000",
    rx: 2.02,
    ry: 3.174,
    transform: "matrix(.92836 -.37381 .3727 .9271 131.684 166.524)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.02,
    cy: 3.174,
    fill: "#000",
    rx: 2.02,
    ry: 3.174,
    transform: "matrix(-.75943 .65182 .65117 .75788 152.212 153.404)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M138.192 153.512c-3.39 2.116-9.053 7.627-4.592 12.744 2.99 3.43 2.553 5.498 2.081 7.734-.409 1.933-.844 3.991.888 7.163 1.573 2.882 3.532 4.376 5.487 5.867 2.688 2.05 5.368 4.094 7.029 9.724 2.295 7.783 13.947 26.967 19.534 35.465l12.667-7.779v-.001l12.525-7.611c-4.969-8.874-16.341-27.977-22.191-33.6-4.121-3.961-4.079-7.211-4.036-10.45.033-2.507.066-5.009-1.833-7.83-2.029-3.015-4.548-3.569-6.972-4.102-2.775-.61-5.427-1.193-7.086-5.406-2.487-6.317-9.987-3.829-13.426-1.795l-.075-.123Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.882,
    cy: 6.877,
    fill: "url(#e)",
    rx: 4.882,
    ry: 6.877,
    transform: "matrix(-.55034 .83558 .8354 .54868 138.977 173.837)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.882,
    cy: 6.877,
    fill: "url(#f)",
    rx: 4.882,
    ry: 6.877,
    transform: "matrix(-1.00003 -.0248 -.0263 .99931 167.419 163.001)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBB",
    d: "M185.093 202.037c-6.68 9.419-19.418 15.226-25.13 16.008l1.863 2.933c13.374-.999 22.204-11.133 25.111-16.031l-1.844-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD500",
    d: "M186.906 204.84c-7.725 11.714-19.422 15.253-25.131 16.104l1.509 2.269c13.384-1.162 22.756-10.165 25.576-15.086l-1.954-3.287Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.906,
    cy: 1.424,
    fill: "#fff",
    opacity: 0.2,
    rx: 0.906,
    ry: 1.424,
    transform: "matrix(.9925 -.12664 .12525 .99156 151.018 154.994)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.906,
    cy: 1.424,
    fill: "#fff",
    opacity: 0.2,
    rx: 0.906,
    ry: 1.424,
    transform: "matrix(.9925 -.12664 .12525 .99156 132.909 166.374)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6B0A",
    d: "M139.661 171.644c-5.606-8.335 1.764-14.774 1.793-14.647 9.632-2.818 13.379 5.026 13.75 6.298 1.021 3.502 7.663 3.11 8.068 7.16.405 4.049 4.396 10.572 5.932 15.88.941 3.253.419 4.968-.231 5.718.217-.129.133-.063-.075.082a1.394 1.394 0 0 1-.518.352c.193-.129.382-.257.518-.352.025-.026.05-.053.075-.082-.286.17-1.091.677-2.814 1.784-4.862 3.123-9.101-3.158-17.851-7.963-8.75-4.805-1.64-3.811-8.647-14.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M164.249 190.696c-4.159 2.054-10.752-5.922-13.529-10.168 2.103-2.009 6.91-5.953 9.318-5.662 3.009.364 9.41 13.261 4.211 15.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#956C7C",
    d: "M164.378 189.099c2.554-2.025-1.989-7.536-4.58-10.039l-5.368 3.263c2.251 3.102 7.393 8.801 9.948 6.776Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86616F",
    d: "M162.758 187.123c.323-.754-4.143-6.225-6.417-8.867l-1.103.843c2.372 2.989 7.197 8.778 7.52 8.024Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB6005",
    d: "M147.095 178.177c-.778-7.288-4.242-9.485-5.877-9.672.822-7.99 7.542-7.704 10.798-6.562.222 7.456-.128 1.596 7.112 8.922 5.791 5.86 2.677 10.941.396 12.749-3.819 1.224-11.651 1.85-12.429-5.437Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFE5D5",
    d: "M161.202 173.519c-11.53-4.736-12.381 4.374-11.366 9.521 1.624 1.375 5.869 3.401 9.855.507 3.986-2.895 2.668-7.892 1.511-10.028Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DACAB0",
    d: "M153.494 176.724c-.513-.688-1.581-1.888-1.751-1.184-.169.705 1.097 1.083 1.751 1.184ZM154.886 175.882c-.491-.704-1.293-2.097-.571-2.035.723.062.682 1.382.571 2.035Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.206,
    cy: 224.499,
    fill: "#fff",
    rx: 14.761,
    ry: 4.019,
    transform: "matrix(.85211 -.52402 .5227 .85211 -90.548 128.156)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M162.796 225.326h33.1v12.95h-33.1z",
    transform: "rotate(-31.558 162.796 225.326)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 117.618,
    x2: 243.573,
    y1: 195.909,
    y2: 160.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 89.36,
    x2: 161.228,
    y1: 149.895,
    y2: 47.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 123.416,
    x2: 167.895,
    y1: 292.446,
    y2: 245.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 272.867,
    x2: 210.825,
    y1: 200.655,
    y2: 219.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 179.346,
    x2: 179.346,
    y1: 225.326,
    y2: 238.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#888",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 6.87666 -4.88203 0 4.882 6.877)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 6.87666 -4.88203 0 4.882 6.877)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("symbol", {
    id: "logout-door-sf",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.333 14.167 17.5 10m0 0-4.167-4.167M17.5 10h-10m0-7.5h-1c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093C2.5 4.4 2.5 5.1 2.5 6.5v7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092C4.4 17.5 5.1 17.5 6.5 17.5h1"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-avatar-f",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.297 39.75c-2.855-4.937-7.256-8.477-12.391-10.155a13.5 13.5 0 1 0-13.812 0C11.96 31.271 7.558 34.811 4.703 39.75a1.5 1.5 0 1 0 2.596 1.5C10.832 35.145 17.076 31.5 24 31.5c6.924 0 13.168 3.645 16.7 9.75a1.5 1.5 0 1 0 2.597-1.5ZM13.5 18A10.5 10.5 0 1 1 24 28.5 10.511 10.511 0 0 1 13.5 18Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-calendar-sf",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 10H3m18 2.5V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 4 17.88 4 16.2 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 22 6.12 22 7.8 22H12m4-20v4M8 2v4m6.5 13 2 2 4.5-4.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-moon-f",
    viewBox: "0 0 27 27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.656 15.393c-.903.24-1.834.362-2.77.362-2.846 0-5.52-1.107-7.527-3.115a10.7 10.7 0 0 1-2.752-10.297A1.333 1.333 0 0 0 9.973.712a13.352 13.352 0 0 0-5.985 3.443c-5.197 5.197-5.197 13.657 0 18.857a13.25 13.25 0 0 0 9.43 3.907 13.238 13.238 0 0 0 9.426-3.906 13.342 13.342 0 0 0 3.444-5.988 1.334 1.334 0 0 0-1.632-1.632Zm-3.696 5.735a10.596 10.596 0 0 1-7.541 3.124 10.605 10.605 0 0 1-7.544-3.125c-4.158-4.159-4.158-10.927 0-15.086.803-.802 1.73-1.47 2.746-1.977a13.37 13.37 0 0 0 3.854 10.464 13.296 13.296 0 0 0 10.464 3.855 10.715 10.715 0 0 1-1.979 2.745Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-plus-s",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 3.75v10.5M3.75 9h10.5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-mobile-menu",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12H21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6H21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18H21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-sun-f",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16A6.683 6.683 0 0 0 16 22.676 6.683 6.683 0 0 0 22.676 16 6.683 6.683 0 0 0 16 9.324 6.683 6.683 0 0 0 9.324 16ZM16 11.99c2.21 0 4.01 1.8 4.01 4.01s-1.8 4.01-4.01 4.01A4.014 4.014 0 0 1 11.99 16c0-2.21 1.8-4.01 4.01-4.01Zm-1.336 13.343h2.667v4h-2.667v-4Zm0-22.666h2.667v4h-2.667v-4Zm-12 12h4v2.666h-4v-2.666Zm22.667 0h4v2.666h-4v-2.666ZM5.625 24.484l2.827-2.83 1.887 1.886-2.827 2.83-1.887-1.886ZM21.653 8.46l2.83-2.83 1.885 1.886-2.83 2.83-1.885-1.886ZM8.456 10.345l-2.83-2.829 1.887-1.885 2.827 2.83-1.884 1.884Zm17.912 14.14-1.885 1.886-2.83-2.83 1.886-1.885 2.829 2.83Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "profile-user-sf",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m16 18 2 2 4-4M12 15.5H7.5c-1.396 0-2.093 0-2.661.172a4 4 0 0 0-2.667 2.667C2 18.907 2 19.604 2 21v0M10 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.586l-7.071-7.071-1.414 1.414 7.071 7.071-7.071 7.071 1.414 1.414 7.071-7.071 7.071 7.071 1.414-1.414-7.071-7.071 7.071-7.071-1.414-1.414-7.071 7.071z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "task-edit-sf",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.334 28.666l7.4-2.846c0.472-0.18 0.708-0.272 0.93-0.392 0.196-0.104 0.384-0.226 0.56-0.364 0.2-0.154 0.378-0.332 0.736-0.69l15.040-15.040c0.703-0.686 1.138-1.642 1.138-2.7 0-2.083-1.689-3.772-3.772-3.772-1.058 0-2.014 0.436-2.699 1.137l-15.041 15.041c-0.243 0.23-0.468 0.47-0.679 0.723l-0.011 0.013c-0.138 0.176-0.26 0.364-0.366 0.56-0.118 0.22-0.208 0.46-0.39 0.932l-2.846 7.4zM3.334 28.666l2.744-7.134c0.196-0.51 0.294-0.766 0.462-0.882 0.106-0.075 0.238-0.12 0.381-0.12 0.044 0 0.087 0.004 0.129 0.012l-0.004-0.001c0.2 0.040 0.394 0.232 0.78 0.62l3.014 3.010c0.386 0.388 0.58 0.58 0.618 0.782 0.007 0.037 0.012 0.080 0.012 0.124 0 0.143-0.045 0.275-0.121 0.384l0.001-0.002c-0.116 0.168-0.372 0.266-0.882 0.462l-7.134 2.744z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "task-move-sf",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4.45 9.334c2.348-4.014 6.638-6.667 11.548-6.667 7.364 0 13.334 5.97 13.334 13.334s-5.97 13.334-13.334 13.334c-4.909 0-9.199-2.653-11.514-6.604l-0.034-0.063"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M16 21.334l5.334-5.334-5.334-5.334M2.666 16h18.668"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "task-trash-sf",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M12 4h8M4 8h24M6.666 8l0.8 12.018c0.15 2.23 0.224 3.346 0.59 4.242 0.673 1.626 1.993 2.868 3.63 3.424l0.042 0.012c0.918 0.304 2.036 0.304 4.272 0.304v0c2.236 0 3.354 0 4.272-0.304 1.679-0.568 2.999-1.81 3.657-3.396l0.015-0.040c0.366-0.896 0.44-2.012 0.588-4.242l0.8-12.018"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "add-btn-s",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 1.167v11.666M1.167 7h11.666"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "edit-btn-s",
    viewBox: "0 0 19 18"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m2.375 16.125 4.162-1.6c.266-.103.4-.154.524-.221.11-.06.216-.128.315-.205.112-.087.213-.188.414-.39l8.46-8.459a2.121 2.121 0 0 0-3-3l-8.46 8.46c-.201.201-.302.302-.389.414-.077.1-.145.205-.205.315-.067.125-.118.258-.22.524l-1.601 4.162Zm0 0 1.544-4.013c.11-.287.165-.431.26-.497a.375.375 0 0 1 .284-.06c.114.021.222.13.44.348l1.694 1.694c.218.218.327.327.348.44a.375.375 0 0 1-.06.284c-.066.095-.21.15-.497.26l-4.013 1.544Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user-chevron-down-sf",
    viewBox: "0 0 55 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.297 7.598c-1.736-1.744-1.728-4.568 0.016-6.303 1.745-1.736 4.568-1.728 6.304 0.016l19.872 19.923 19.872-19.923c1.736-1.744 4.559-1.752 6.304-0.016 1.744 1.735 1.752 4.559 0.016 6.303l-23.050 23.107c-1.744 1.736-4.568 1.728-6.303-0.016l-23.032-23.090z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "closed-eye",
    viewBox: "0 0 59 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.23,18.54l11.05-11A2.46,2.46,0,0,0,54.8,4h0L.72,58.1A2.46,2.46,0,0,0,4.2,61.57h0l12-12A31.9,31.9,0,0,0,29.5,52.46,32.59,32.59,0,0,0,58.75,33.88a2.5,2.5,0,0,0,0-2.17A33.53,33.53,0,0,0,47.23,18.54ZM29.5,45.08a12.13,12.13,0,0,1-6.76-2l3.59-3.59a7.35,7.35,0,0,0,10.54-6.65,7.26,7.26,0,0,0-.73-3.17L39.74,26a12.27,12.27,0,0,1-10.24,19ZM.25,33.88a2.5,2.5,0,0,1,0-2.17A32.58,32.58,0,0,1,29.5,13.12a32.13,32.13,0,0,1,8.11,1.07l-6.44,6.44A12.2,12.2,0,0,0,17.34,34.47L7.82,44A34.08,34.08,0,0,1,.25,33.88Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "opened-eye",
    viewBox: "0 0 59 64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.87,32.79a7.38,7.38,0,1,1-7.37-7.37A7.38,7.38,0,0,1,36.87,32.79Zm21.88,1.09A32.59,32.59,0,0,1,29.5,52.46,32.59,32.59,0,0,1,.25,33.88a2.5,2.5,0,0,1,0-2.17A32.58,32.58,0,0,1,29.5,13.12,32.58,32.58,0,0,1,58.75,31.71,2.5,2.5,0,0,1,58.75,33.88Zm-17-1.09A12.29,12.29,0,1,0,29.5,45.08,12.29,12.29,0,0,0,41.79,32.79Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "starStartPage",
    viewBox: "0 0 14 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8241 14C10.6578 14 10.4922 13.9466 10.3498 13.8403L7.00009 11.3293L3.65039 13.8403C3.51161 13.9447 3.34483 14.0005 3.17386 13.9999C3.00289 13.9993 2.83648 13.9422 2.69839 13.8369C2.56018 13.7321 2.45708 13.5845 2.40378 13.4149C2.35048 13.2454 2.34969 13.0626 2.40151 12.8925L3.6508 8.67793L0.331167 6.23275C0.193589 6.12662 0.0914162 5.97796 0.0390997 5.8078C-0.0132167 5.63764 -0.0130282 5.45459 0.0396388 5.28455C0.0927213 5.11492 0.195461 4.96702 0.333337 4.86175C0.471213 4.75648 0.637253 4.69916 0.807989 4.6979L4.91945 4.69144L6.22844 0.58142C6.28246 0.412106 6.38607 0.264848 6.5246 0.160499C6.66312 0.0561503 6.82954 0 7.00029 0C7.17104 0 7.33746 0.0561503 7.47599 0.160499C7.61451 0.264848 7.71812 0.412106 7.77214 0.58142L9.0589 4.69144L13.1914 4.6979C13.3623 4.69891 13.5286 4.75619 13.6666 4.86162C13.8046 4.96705 13.9073 5.11526 13.9602 5.2852C14.013 5.45513 14.0133 5.63815 13.9609 5.80825C13.9086 5.97835 13.8063 6.12688 13.6686 6.23275L10.349 8.67793L11.5982 12.8925C11.6502 13.0625 11.6495 13.2453 11.5963 13.4149C11.543 13.5844 11.44 13.7321 11.3018 13.8369C11.1633 13.9431 10.9959 14.0002 10.8241 14Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arRight",
    viewBox: "0 0 39 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.865 1.10971L35.7445 2.38771L0 2.38871L0 3.38871L35.5205 3.38771L33.75 4.40522L34.248 5.27222L38.3225 2.93122L34.4275 0.282713L33.865 1.10971Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arLeft",
    viewBox: "0 0 39 6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.03685 4.66763L3.15734 3.38963L38.9019 3.38863V2.38863L3.38134 2.38963L5.15184 1.37213L4.65384 0.505127L0.579338 2.84613L4.47435 5.49463L5.03685 4.66763Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    width: 14,
    height: 13,
    viewBox: "0 0 32 32",
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30.144l-2.24-2.218c-8.32-7.287-13.76-12.198-13.76-18.218 0-4.911 3.84-8.713 8.8-8.713 2.72 0 5.44 1.267 7.2 3.327 1.76-2.059 4.48-3.327 7.2-3.327 4.96 0 8.8 3.802 8.8 8.713 0 6.020-5.44 10.931-13.76 18.218l-2.24 2.218z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-github",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 .247c-5.525 0-10 4.478-10 10a9.997 9.997 0 0 0 6.837 9.487c.5.094.683-.215.683-.481 0-.238-.008-.867-.013-1.7-2.782.603-3.368-1.342-3.368-1.342-.455-1.154-1.112-1.462-1.112-1.462-.906-.62.07-.608.07-.608 1.004.07 1.532 1.03 1.532 1.03.892 1.529 2.341 1.087 2.913.832.09-.647.348-1.088.633-1.338-2.221-.25-4.555-1.11-4.555-4.942 0-1.092.388-1.983 1.029-2.683-.112-.253-.45-1.269.087-2.647 0 0 .838-.268 2.75 1.025.8-.223 1.65-.333 2.5-.338.85.005 1.7.115 2.5.337 1.9-1.293 2.737-1.025 2.737-1.025.537 1.378.2 2.394.1 2.647.637.7 1.025 1.592 1.025 2.683 0 3.842-2.338 4.688-4.563 4.933.35.3.675.913.675 1.85 0 1.338-.012 2.413-.012 2.738 0 .262.175.575.688.475a9.966 9.966 0 0 0 6.863-9.474c0-5.523-4.478-10-10-10z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-linkedin",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5h3.459v1.773h.049c.481-.863 1.659-1.773 3.415-1.773 3.651 0 4.326 2.273 4.326 5.229v6.021h-3.606v-5.337c0-1.273-.026-2.911-1.876-2.911-1.878 0-2.164 1.386-2.164 2.818v5.43H7.499V7.5zM1.25 7.5H5v11.25H1.25V7.5zM5 4.375a1.874 1.874 0 1 1-3.749.001A1.874 1.874 0 0 1 5 4.375z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-closeBTN",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1333,
    d: "M8.533 8.533l14.933 14.933"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2.1333,
    d: "M8.533 23.467l14.933-14.933"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-check",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M21.333 24l2.667 2.667 5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M16 20.667h-6c-0.867 0-1.3 0-1.665 0.042-2.955 0.34-5.287 2.671-5.627 5.627-0.042 0.365-0.042 0.798-0.042 1.665v0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.88,
    d: "M13.333 16c3.314 0 6-2.686 6-6s-2.686-6-6-6c-3.314 0-6 2.686-6 6s2.686 6 6 6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-text",
    viewBox: "0 0 160 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.256 28v-11.424h-8.864v3.552h4.704c0 2.656-2.272 4.864-5.184 4.864-4.128 0-5.888-3.968-5.888-7.456 0-5.056 2.368-7.808 5.92-7.808 2.432 0 4.576 1.6 4.8 3.584h4.48c-0.32-4.256-4.224-7.264-9.28-7.264-6.88 0-10.464 5.024-10.464 11.296 0 5.92 3.744 11.392 9.632 11.392 2.912 0 5.344-1.056 6.368-2.848l0.096 2.112h3.68zM30.183 24.928c-2.080 0-3.104-0.8-3.104-3.52 0-3.712 1.536-6.048 4.8-6.048 2.048 0 3.104 0.64 3.104 3.488 0 3.712-1.568 6.080-4.8 6.080zM29.575 28.416c5.632 0 9.632-4.096 9.632-9.856 0-4.064-2.464-6.72-6.72-6.72-5.728 0-9.728 4.096-9.728 9.824 0 4 2.4 6.752 6.816 6.752zM47.433 24.928c-2.080 0-3.104-0.8-3.104-3.52 0-3.712 1.536-6.048 4.8-6.048 2.048 0 3.104 0.64 3.104 3.488 0 3.712-1.568 6.080-4.8 6.080zM46.825 28.416c5.632 0 9.632-4.096 9.632-9.856 0-4.064-2.464-6.72-6.72-6.72-5.728 0-9.728 4.096-9.728 9.824 0 4 2.4 6.752 6.816 6.752zM69.867 17.024c-0.224-3.392-2.272-5.184-6.816-5.184-4.8 0-6.624 2.016-6.624 4.672 0 1.408 0.512 2.624 1.984 3.552 1.12 0.704 2.592 1.152 5.248 1.792 1.344 0.32 2.528 0.672 2.528 1.792 0 1.184-1.312 1.632-2.784 1.632-2.016 0-3.264-0.864-3.264-2.336h-4.288c0.064 3.2 2.752 5.472 7.584 5.472 4.48 0 6.88-1.952 6.88-5.216 0-2.048-0.928-3.136-2.592-3.808-1.216-0.48-2.912-0.832-4.704-1.344-1.696-0.48-2.56-0.864-2.56-1.792s0.896-1.312 2.464-1.312c1.888 0 2.72 0.544 2.944 2.080h4zM75.424 18.592c0.16-2.176 1.536-3.456 3.2-3.456 1.632 0 3.168 1.12 3.232 3.456h-6.432zM86.144 21.216c0-6.24-2.56-9.376-7.392-9.376s-7.616 3.136-7.616 8c0 5.696 2.624 8.576 7.872 8.576 3.36 0 5.952-1.824 6.912-5.056h-4.288c-0.288 1.088-1.472 1.76-2.816 1.76-2.048 0-3.392-1.536-3.52-3.904h10.848zM97.726 28v-17.536h6.432v-3.712h-17.28v3.712h6.4v17.536h4.448zM107.805 28v-8.192c0-2.528 1.248-3.808 3.808-3.808 0.384 0 0.768 0.032 1.152 0.096v-4.256h-0.544c-1.696 0-3.296 0.192-4.672 2.304v-1.888h-3.904v15.744h4.16zM122.681 22.016c-0.032 1.856-1.632 3.424-3.776 3.424-1.312 0-2.016-0.576-2.016-1.76 0-1.344 0.768-2.016 3.136-2.464 1.536-0.288 2.272-0.512 2.688-0.928l-0.032 1.728zM126.873 28v-9.952c0-3.968-1.728-6.208-6.72-6.208-5.056 0-6.848 2.272-6.912 5.536h3.872c0.192-1.408 0.96-2.336 2.848-2.336 1.632 0 2.656 0.608 2.656 1.632 0 1.088-0.576 1.504-2.656 1.792-4.192 0.576-7.232 1.088-7.232 5.632 0 2.56 1.664 4.32 5.248 4.32 2.112 0 3.776-0.736 4.768-1.824 0.032 0.48 0.128 1.024 0.256 1.408h3.872zM138.691 22.304c-0.16 1.696-1.44 2.624-3.072 2.624s-3.072-1.664-3.072-5.088c0-3.424 1.44-4.544 3.2-4.544 1.568 0 2.752 0.96 2.976 2.592h4.192c-0.256-3.712-3.040-6.048-7.136-6.048-4.416 0-7.36 2.464-7.36 8.096s2.944 8.48 7.232 8.48c3.808 0 6.784-2.464 7.232-6.112h-4.192zM158.449 28l-5.152-9.952 5.28-5.792h-5.088l-5.184 5.984v-11.744h-4.192v21.504h4.192v-4.992l2.016-2.080 3.456 7.072h4.672z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-input-correct",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.76 18.88l-3.48-3.48c-0.293-0.293-0.66-0.433-1.099-0.419-0.441 0.013-0.807 0.166-1.101 0.459s-0.44 0.667-0.44 1.12c0 0.453 0.147 0.827 0.44 1.12l4.56 4.56c0.293 0.293 0.667 0.44 1.12 0.44s0.827-0.147 1.12-0.44l9.080-9.080c0.293-0.293 0.434-0.66 0.421-1.101-0.014-0.439-0.168-0.806-0.461-1.099s-0.667-0.44-1.12-0.44c-0.453 0-0.827 0.147-1.12 0.44l-7.92 7.92zM16 32c-2.213 0-4.293-0.42-6.24-1.261s-3.64-1.979-5.080-3.419-2.58-3.133-3.419-5.080c-0.841-1.947-1.261-4.027-1.261-6.24s0.42-4.293 1.261-6.24c0.839-1.947 1.979-3.64 3.419-5.080s3.133-2.58 5.080-3.421c1.947-0.839 4.027-1.259 6.24-1.259s4.293 0.42 6.24 1.259c1.947 0.841 3.64 1.981 5.080 3.421s2.58 3.133 3.419 5.080c0.84 1.947 1.261 4.027 1.261 6.24s-0.42 4.293-1.261 6.24c-0.84 1.947-1.979 3.64-3.419 5.080s-3.133 2.58-5.080 3.419c-1.947 0.84-4.027 1.261-6.24 1.261zM16 28.8c3.547 0 6.567-1.246 9.061-3.739 2.493-2.494 3.739-5.514 3.739-9.061s-1.246-6.567-3.739-9.061c-2.494-2.493-5.514-3.739-9.061-3.739s-6.566 1.246-9.059 3.739c-2.494 2.494-3.741 5.514-3.741 9.061s1.247 6.567 3.741 9.061c2.493 2.493 5.513 3.739 9.059 3.739z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-input-error",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4 20.8h3.2v3.2h-3.2v-3.2zM14.4 8h3.2v9.6h-3.2v-9.6zM15.984 0c-8.832 0-15.984 7.168-15.984 16s7.152 16 15.984 16c8.848 0 16.016-7.168 16.016-16s-7.168-16-16.016-16zM16 28.8c-7.072 0-12.8-5.728-12.8-12.8s5.728-12.8 12.8-12.8c7.072 0 12.8 5.728 12.8 12.8s-5.728 12.8-12.8 12.8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-google",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbc02d",
    d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20 s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039 l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M43.611,20.083L43.595,20L42,20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "swagger-icon",
    viewBox: "0 0 256 256"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#85EA2D",
    d: "M127.999 249.895c-67.215 0-121.9-54.68-121.9-121.896C6.1 60.782 60.785 6.102 128 6.102c67.214 0 121.899 54.685 121.899 121.9c0 67.214-54.685 121.893-121.9 121.893Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#173647",
    d: "M127.999 12.202c63.954 0 115.797 51.842 115.797 115.797c0 63.952-51.843 115.797-115.797 115.797c-63.952 0-115.797-51.845-115.797-115.797S64.047 12.202 127.999 12.202m0-12.202C57.419 0 0 57.42 0 127.999s57.42 127.998 127.999 127.998S256 198.577 256 128C256 57.419 198.578 0 127.999 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#173647",
    d: "M80.598 86.619c-.394 4.38.146 8.909-.146 13.338c-.345 4.431-.887 8.811-1.773 13.192c-1.23 6.25-5.12 10.976-10.482 14.914c10.436 6.793 11.616 17.324 12.304 28.006c.345 5.76.197 11.567.788 17.276c.443 4.429 2.165 5.562 6.745 5.708c1.87.048 3.786 0 5.956 0v13.683c-13.535 2.313-24.708-1.525-27.467-12.992c-.887-4.184-1.478-8.467-1.673-12.798c-.297-4.578.195-9.155-.148-13.732c-.985-12.553-2.61-16.785-14.618-17.376v-15.602a23.714 23.714 0 0 1 2.608-.443c6.596-.345 9.4-2.364 10.828-8.86c.69-3.641 1.084-7.333 1.23-11.074c.494-7.136.297-14.42 1.525-21.507C67.997 68.163 74.3 63.24 84.785 62.65c2.952-.149 5.955 0 9.35 0v13.98c-1.427.1-2.658.294-3.937.294c-8.515-.297-8.96 2.607-9.6 9.695Zm16.39 32.386h-.196c-4.923-.245-9.155 3.593-9.403 8.515c-.246 4.972 3.592 9.206 8.515 9.45h.59c4.875.296 9.056-3.447 9.352-8.319v-.491c.1-4.971-3.886-9.055-8.857-9.155Zm30.862 0c-4.774-.148-8.763 3.593-8.909 8.318c0 .297 0 .543.051.837c0 5.365 3.641 8.812 9.155 8.812c5.414 0 8.812-3.544 8.812-9.106c-.051-5.366-3.646-8.91-9.109-8.86Zm31.602 0c-5.02-.1-9.206 3.89-9.352 8.91a9.03 9.03 0 0 0 9.055 9.054h.1c4.528.788 9.106-3.592 9.402-8.858c.243-4.874-4.186-9.106-9.205-9.106Zm43.363.737c-5.711-.245-8.567-2.164-9.992-7.581a54.874 54.874 0 0 1-1.624-10.582c-.395-6.596-.346-13.241-.789-19.837c-1.033-15.651-12.352-21.114-28.794-18.41V76.92c2.607 0 4.626 0 6.645.049c3.495.048 6.153 1.379 6.496 5.268c.345 3.543.345 7.136.69 10.73c.692 7.139 1.083 14.372 2.314 21.41c1.085 5.809 5.07 10.14 10.04 13.684c-8.71 5.857-11.27 14.223-11.714 23.626c-.245 6.448-.394 12.944-.736 19.443c-.297 5.905-2.362 7.824-8.318 7.972c-1.674.05-3.298.198-5.169.297v13.93c3.495 0 6.694.196 9.892 0c9.942-.592 15.947-5.415 17.918-15.063a125.582 125.582 0 0 0 1.476-16.045c.343-4.923.297-9.894.788-14.766c.737-7.63 4.232-10.78 11.862-11.27c.739-.1 1.427-.246 2.118-.492v-15.604c-1.282-.149-2.17-.295-3.103-.346Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.b86ac313b6c9e4baccf54b53fb404b51.svg";
export { ForwardRef as ReactComponent };